import { useState, FormEvent } from "react";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const form = e.currentTarget;
    const formData = new FormData(form);
    const phoneAlt = formData.get("phone_alt") as string;
    if (phoneAlt && phoneAlt.trim() !== "") {
      setLoading(false);
      setSubmitted(true);
      return;
    }

    try {
      const res = await fetch(
        "https://readdy.ai/api/form/d9u58o53pcjqs2fcsmc0",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            email: formData.get("email") as string,
          }).toString(),
        }
      );
      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      if (res.ok && parsed?.code === "OK") {
        setSubmitted(true);
        setEmail("");
      } else {
        const msg =
          parsed?.meta?.message ||
          parsed?.message ||
          parsed?.meta?.detail ||
          "订阅失败，请稍后再试";
        setError(msg);
      }
    } catch {
      setError("网络错误，请检查您的网络连接后重试");
    }
    setLoading(false);
  };

  return (
    <section className="py-16 bg-accent-500">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 text-center">
        <h2
          className="text-2xl md:text-3xl font-bold text-background-50"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          订阅最新资讯
        </h2>
        <p className="mt-2 text-background-50/80 text-sm mb-8">
          第一时间获取佐佐木希最新动态、写真及独家内容
        </p>

        {submitted ? (
          <div className="max-w-md mx-auto bg-background-50/10 backdrop-blur-sm rounded-lg p-4 border border-background-50/20">
            <p className="text-background-50 font-medium">
              订阅成功！感谢您的关注，我们将定期为您推送最新资讯。
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form="true"
            id="newsletter-form"
            className="max-w-md mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                required
                className="flex-1 px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-950 placeholder:text-foreground-400 border-0 outline-none focus:ring-2 focus:ring-background-50/50"
              />
              <button
                type="submit"
                disabled={loading}
                className="px-8 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap disabled:opacity-60"
              >
                {loading ? "订阅中..." : "立即订阅"}
              </button>
            </div>
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="phone-alt-field"
            />
            {error && (
              <p className="mt-3 text-sm text-background-50/90 bg-red-500/20 rounded-lg px-4 py-2">
                {error}
              </p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}